import React, { FC } from 'react';

import './MobileSdkVersionCellFormatter.scss';

interface IMobileSdkVersionCellFormatterProps {
	label: string;
	version: string;
}

export const MobileSdkVersionCellFormatter: FC<IMobileSdkVersionCellFormatterProps> = ({
	label,
	version
}) => {
	return (
		<div className="mobile-sdk-version-cell-formatter">
			<p className="label">{label}</p>
			<p className="version">{version}</p>
		</div>
	);
};
